import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpClientService } from '../../../../../core/services/http-client.service';
import type { IncidentTransactionsClient } from '../../../../../core/tokens/incident-transactions-client.token';
import { INCIDENTS } from '../../../../../shared/constants/api-routes.constants';
import type { IncidentTransactionsResponse } from '../models/incident-transactions-response.model';

@Injectable({ providedIn: 'root' })
export class IncidentTransactionsService implements IncidentTransactionsClient {
  private readonly http = inject(HttpClientService);

  getTransactions(incidentNumber: string, organizationId: string): Observable<IncidentTransactionsResponse> {
    const params = new HttpParams().set('organizationId', organizationId);
    return this.http.get<IncidentTransactionsResponse>(INCIDENTS.TRANSACTIONS(incidentNumber), { params });
  }
}
